import React from "react";
import * as Constants from "../utils/constants";
import { WithTranslationLangProps } from "../utils/i18next/with-translation-keys";
import { withTranslation } from "react-i18next";
import {
  getLocalisedContent,
  MarkdownStrContent,
} from "../utils/i18next/localised-content";
import ReactMarkdown from "react-markdown";

interface IMapExplainModalProps extends WithTranslationLangProps {
  onClose: () => void;
}

interface IMapExplainModalState {
  shouldDisplay: boolean;
  modalContent: MarkdownStrContent | undefined;
}

class MapExplainModal extends React.Component<
  IMapExplainModalProps,
  IMapExplainModalState
> {
  private modalRef: React.RefObject<HTMLDivElement>;
  
  constructor(props: IMapExplainModalProps) {
    super(props);
    this.modalRef = React.createRef();
    let shouldDisplay = true;
    this.state = { modalContent: undefined, shouldDisplay: shouldDisplay };
    this.updateModalContent = this.updateModalContent.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.componentDidUpdate = this.componentDidUpdate.bind(this);
    this.closeModalClicked = this.closeModalClicked.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  updateModalContent() {
    if (this.props.i18n.resolvedLanguage !== undefined) {
      getLocalisedContent(Constants.CONTENT_MAP_EXPLAIN, this.props.i18n).then(
        (result) => {
          this.setState({
            modalContent: result,
          });
        }
      );
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    if (this.props.i18n.resolvedLanguage !== this.state.modalContent?.locale) {
      this.updateModalContent();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(
    _prevProps: IMapExplainModalProps,
    _prevState: IMapExplainModalState
  ) {
    if (
      _prevProps.t !== this.props.t ||
      this.props.i18n.resolvedLanguage !== this.state.modalContent?.locale
    ) {
      this.updateModalContent();
    }
  }

  private closeModalClicked() {
    this.setState({ shouldDisplay: false });
    this.props.onClose.call(this);
  }

  private handleClickOutside(event: MouseEvent) {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target as Node)) {
      this.props.onClose();
    }
  }

  render() {
    return (
      <>
        {this.state.shouldDisplay && this.state.modalContent !== undefined && (
          <div className="map-modal content" ref={this.modalRef}>
            <button
              className="prveo-btn menu-close-btn"
              onClick={this.closeModalClicked}
            >
              &#x2715;
            </button>
            <div className="mx-2">
              <ReactMarkdown children={this.state.modalContent.content} />
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withTranslation()(MapExplainModal);
